<template>
  <div class="bargainList">
    <div class="bargainItem" v-for="(item,index) in list" :key="index">
      <div class="delBox">
        <el-checkbox v-if="allcheckedShow" v-model="item.checkbox" @change="checkboxChange(item,index)"/>
      </div>
      <div class="img">
        <el-image :src="item.image"></el-image>
      </div>
      <div class="baseInfo">
        <div class="number">
          商品编号：{{ item.unique_no }}
        </div>
        <div class="name" v-if="selectItem === '游戏账号'">
          <span class="status" v-if="item.goodsStatus === 1" style="color: #FCAD13;background: #FFF2D9">在售</span>
          <span class="status" v-else-if="item.goodsStatus === 2" style="color: #389D16;background: #D8FCDE">已售</span>
          <span class="status" v-else-if="item.goodsStatus === 3" style="color: #BFBFBF;background: #F0F0F0">已下架</span>
          <span class="status" v-else-if="item.goodsStatus === 6" style="color: #F0EDE8;background: #F0EDE8">交易中</span>
          {{ item.name }}
        </div>
        <div class="name" v-else>
          <span class="status" v-if="item.goodsStatus === 2" style="color: #FCAD13;background: #FFF2D9">在售</span>
          <span class="status" v-else-if="item.goodsStatus === 3" style="color: #BFBFBF;background: #F0F0F0">已下架</span>
          {{ item.name }}
        </div>
        <div class="price">
          <div class="originalPrice">商品原价：
            <div>¥{{ item.price }}</div>
          </div>
          <div class="quotedPrice">
            <img src="@/assets/image/PersonalCenter/Seller/price_tip.png" alt="">
            {{type==='seller'?'买家报价':'您的报价'}}
            ：
            <div>¥{{ item.bargain_price }}</div>
          </div>
        </div>
        <div class="zone">
          游戏区服职业：{{ item.game_name }}<span v-for="(items,indexs) in item.category"
                                           :key="indexs">-{{ items.value }}</span>
        </div>
        <div class="other">
          <div class="browse">浏览：{{ item.click }}</div>
          <div class="collect">收藏：{{ item.collect }}</div>
        </div>
        <div class="time">
          发布时间：{{ item.add_time|moments }}
        </div>
      </div>
      <div class="operating">
        <div class="status" v-if="item.status === 1 " style="color: #F7F5F2">
          <img src="@/assets/image/PersonalCenter/Seller/waiting.png" alt="">{{ type === 'seller' ? '待您处理' : '待卖家处理' }}
        </div>
        <div class="status" v-else-if="item.status === 2 " style="color: #38DF3E">
          <img src="@/assets/image/PersonalCenter/Seller/agree.png" alt="">{{ type === 'seller' ? '您已同意' : '卖家已同意' }}
        </div>
        <div class="status" v-else-if="item.status === 3 && item.sell_price === '0.00' " style="color: #FF6767">
          <img src="@/assets/image/PersonalCenter/Seller/refuse.png" alt="">{{ type === 'seller' ? '您已拒绝' : '卖家已拒绝' }}
        </div>
        <div class="status" v-else-if="item.status === 4 || item.is_invalid === 1 " style="color: #FF6767">
          <img src="@/assets/image/PersonalCenter/Seller/refuse.png" alt="">{{ type === 'seller' ? '同意后失效' : '同意后失效' }}
        </div>
        <div class="status" v-else-if="item.status === 3 && item.sell_price !== '0.00'" style="color: #FF8B02">
          <img src="@/assets/image/PersonalCenter/Seller/reject.png" alt="">{{ type === 'seller' ? '您已还价：' : '卖家还价：' }}¥{{item.sell_price}}
        </div>
        <div class="time" v-if="item.status !== 1 && item.user_res_time!==0">{{item.status===3 ? '还价': item.status===2 || item.status===4?'同意':'拒绝'}}时间：{{ item.user_res_time | moments }}</div>
        <div class="time" style="color: #515151;" v-if="item.status ==2 && item.expire_time!==0">有效期至：{{ item.expire_time | moments }}</div>
        <div class="btnGroup">
          <div v-if="type==='seller'">
            <a class="cusSer btn" @click="cusSerBtnClicks(item)" v-if="item.status === 2"
               href="#">咨询客服</a>
            <!-- <a class="cusSer btn" target="_blank" @click="$accessLink(item.game_customer_buy)" v-if="item.status === 2&&item.sys_service_type!=2"
               :href="`${item.game_customer_buy}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`">咨询客服</a> -->
            <div class="edit btn" v-else-if="item.status === 1 && type==='seller'"><span @click="agree_confirm(item,'拒绝')">拒绝</span>｜<span @click="refuse_confirm(item)">还价</span></div>
            <div class="agree btn" v-if="item.status === 1 && type==='seller'" @click="agree_confirm(item,'同意')">同意</div>
          </div>
          <div v-else-if="type==='buyer'">
            <div v-if="item.buy_button_show==1&&item.sys_service_type==2&&item.is_online_purchase == 0&&selectItemIndex==0"  class="btn modify" @click="gobuynow(item)">立即购买</div>
            <div v-else-if="item.buy_button_show==1&&item.sys_service_type==2&&item.is_online_purchase == 1&&selectItemIndex==0"  class="btn modify" @click="onlineBuy(item)">立即购买</div>
            <div v-if="item.buy_button_show==1&&item.sys_service_type!=2&&selectItemIndex==0"  class="btn modify" @click="gobuynow(item)">立即购买</div>

            <a class="btn" :class="item.buy_button_show==1?'other':'cusSer'" @click="cusSerBtnClicks(item)" v-if="item.status === 2"
               href="#">咨询客服</a>
            <!-- <a class="btn" :class="item.buy_button_show==1?'other':'cusSer'" target="_blank" @click="$accessLink(item.game_customer_buy)" v-if="item.status === 2&&item.sys_service_type!=2"
               :href="`${item.game_customer_buy}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`">咨询客服</a> -->
            <div class="modify btn" :class="item.status === 3 && item.sell_price-0 > 0?'btn_size':''" v-if="item.status === 3 && item.sell_price-0 > 0" @click="buyuserAgreeBargain(item)">同意出价</div>
            <div class="modify btn" :class="item.status === 3 && item.sell_price-0 > 0?'btn_size':''" v-if="item.status !== 2 && item.status !== 4" @click="change_price(item)">重新出价</div>
            <a class="other btn" :class="item.status === 3 && item.sell_price-0 > 0?'btn_size':''" @click="cusSerBtnClicks(item)" v-if="item.status !== 2 && item.status !== 4 && item.sys_service_type==2"
               href="#">咨询客服</a>
            <!-- <a class="other btn" :class="item.status === 3 && item.sell_price-0 > 0?'btn_size':''" target="_blank" @click="$accessLink(item.game_customer_buy)" v-if="item.status !== 2&&item.sys_service_type!=2"
               :href="`${item.game_customer_buy}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`">咨询客服</a> -->
          </div>
        </div>
      </div>
    </div>
    <mydialog :text="'尊敬的游严选VIP您好，根据相关法律法规要求，需实名认证方可进行购买。'" :btn-text="'去实名'" btn :show="realNameShow"
              :close-fun="mydialogClose" :btn-fuc="mydialogBtnClick"
    ></mydialog>
    <el-dialog
      :visible.sync="tipDialog"
      custom-class="tipDialog"
      :show-close="false"
      width="358px"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      @close="close()"
      top="35vh"
      center>
      <div id="tipDialog">
        <div class="title">是否同意出价</div>
        <div class="text">
          <!-- 是否同意出价 -->
        </div>
        <div class="btn_wrapper">
          <div class="btn" @click="btnFuc()">是</div>
          <div class="btn btn_cancel" @click="close()">否</div>
        </div>
        <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="close()">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {apiStatisticsAdd,apigetSnapUp,apiProductBuyCheck,apiuserInfo,apiBuyuserAgreeBargain} from "@/request/API";
import mydialog from "@/components/myDialog";

export default {
  name: "bargainItem",
  components: {
    mydialog,
  },
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    apiBargain: {
      type: Function,
      default: null
    },
    allcheckedShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default() {
        return ''
      }
    },
    selectItem:{
      type: String,
      default() {
        return '游戏账号'
      }
    },
    selectItemIndex:{
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      agreeBargainId: '',
      tipDialog: false,
      //立即购买 实名弹窗
      realNameShow: false,
    }
  },
  methods: {
    btnFuc(){
      apiBuyuserAgreeBargain({id:this.agreeBargainId}).then(res => {
        this.tipDialog = false
        this.agreeBargainId = ''
        this.$emit('refreshData')
      })
    },
    close() {
      this.tipDialog = false
      this.agreeBargainId = ''
    },
    /**
     * @description: 同意出价
     * @return {*}
     */
    buyuserAgreeBargain(item) {
      this.agreeBargainId = item.id
      this.tipDialog = true
    },
    /**
     * 关闭实名认证提示框
     */
     mydialogClose() {
      this.realNameShow = false
    },
    mydialogBtnClick() {
      this.$router.push({
        path: '/personalCenter/personalInfo/rNameAuthentication',
        query: {
          Rurl: this.$route.fullPath,
        },
      })
    },
    /**
     * @description: 在线购买
     * @param {*} item
     * @return {*}
     */
    onlineBuy(item){
      apiProductBuyCheck({
        game_id:item.game_id,
        id:item.product_id,
      }).then(res=>{
        let routeUrl = this.$router.resolve({
          name: 'OnlineDeal',
          query: {
            id: item.product_id,
            game_id:item.game_id
          }
        });
        window.open(routeUrl.href, '_blank');
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    /**
     * @description: 立即购买
     * @return {*}
     */
    async gobuynow(item) {
      let userInfo = await apiuserInfo({action: 'verified'})
      if (
          (userInfo.data.cert_id === '' &&
          this.$store.state.systemInfo.real_name_auth == '1' &&
          this.$store.state.userData.country_code == '86') ||
          (userInfo.data.cert_id === '' &&
          this.$store.state.systemInfo.real_name_auth == '0')
        ) {
        this.realNameShow = true
        return
      }
      // is_online_purchase等于1去立即购买 等于0就跳咨询客服
      if(item.is_online_purchase == 1) {
        let routeUrl = this.$router.resolve({
          name: "OnlineDeal",
          query: {
            id: item.product_id,
            game_id: item.game_id,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$customerShunt.getBuyOrGroupCode(item.product_id, item.game_id, 1, (data) => {
          if(data.game_buy_status){
            this.onlineBuy(item)
          }else {
            this.$openIM({
              game_id: item.game_id,
              shopid: item.product_id,
              product_type: 1,
              gameAlias: data.group_code,
              im_type: 3
            })
          }
        })
        // apigetSnapUp().then(res => {
        //   if(res.data.snap_up_switch == '1'){
        //     this.$openIM({
        //       ysdgcode: 'ljgm',
        //       game_id: item.game_id,
        //       shopid: item.product_id,
        //       product_type: 1,
        //       gameAlias: 'ljgm',
        //     })
        //   } else {
        //     this.$openIM({
        //       game_id: item.game_id,
        //       shopid: item.product_id,
        //       product_type: 1,
        //       gameAlias: 'ljgm',
        //     })
        //   }
        // })
      }


    },
    cusSerBtnClicks(item) {
      this.statisticsAdd(item)
      if(this.type==='buyer'){
        if(item.game_id && item.product_id){
          this.$customerShunt.getBuyOrGroupCode(item.product_id, item.game_id, this.selectItemIndex==0?1:2, (data) => {
            // 当前游戏是否开启在线支付
            if(data.game_buy_status){
              // 当前规则是否开启在线支付
              data.allot_group_buy_status ? this.onlineBuy(item) : this.$openIM({
                game_id: item.game_id,
                shopid: item.id,
                product_type: this.selectItemIndex==0?1:2,
                gameAlias: data.group_code,
                im_type: 3
              })
            } else {
              this.$openIM({
                game_id: item.game_id,
                shopid: item.product_id,
                product_type: this.selectItemIndex==0?1:2,
                gameAlias: data.group_code,
                im_type: 3
              })
            }
          })
        } else {
          this.$openIM({
            game_id: item.game_id,
            shopid: item.product_id,
            product_type: this.selectItemIndex==0?1:2,
            gameAlias: item.game_alias
          })
        }
      } else {
        if(item.game_id && item.product_id){
          this.$customerShunt.getBuyOrGroupCode(item.product_id, item.game_id, this.selectItemIndex==0?1:2, (data) => {
            this.$openIM({
              game_id: item.game_id,
              shopid: item.product_id,
              product_type: this.selectItemIndex==0?1:2,
              gameAlias: data.group_code,
              im_type: 3
            })
          })
        } else {
          this.$openIM({
            game_id: item.game_id,
            shopid: item.product_id,
            product_type: this.selectItemIndex==0?1:2,
            gameAlias: item.game_alias
          })
        }
      }
    },
    statisticsAdd(item){
      apiStatisticsAdd({
        game_id:item.game_id,
        product_id:item.id,
        statistics_type:3
      })
    },
    /**
     * 选择按钮
     * @param item
     * @param index
     */
    checkboxChange(item, index) {
      this.$parent.allCheckedCancel()
    },
    /**
     * 卖家 同意&拒绝按钮
     * @param item
     */
    agree_confirm(item,type){
      if ((item.goodsStatus !== 1 && this.selectItem === '游戏账号') || (item.goodsStatus !== 2 && this.selectItem === '装备道具')) {
        this.$message({
          type: 'error',
          center: true,
          message: this.selectItem === '游戏账号' ? '您的账号不在出售中，无法同意/拒绝降价请求。':'您的装备道具不在出售中，无法同意/拒绝降价请求。'
        })
        return
      }
      this.$parent.agree_confirm(item,type)
    },
    /**
     * 卖家 还价按钮
     * @param item
     */
    refuse_confirm(item){
      if ((item.goodsStatus !== 1 && this.selectItem === '游戏账号') || (item.goodsStatus !== 2 && this.selectItem === '装备道具')) {
        this.$message({
          type: 'error',
          center: true,
          message: this.selectItem === '游戏账号' ? '您的账号不在出售中，无法同意/拒绝降价请求。':'您的装备道具不在出售中，无法同意/拒绝降价请求。'
        })
        return
      }
      this.$parent.refuse_confirm(item)
    },
    /**
     * 买家 修改价格按钮
     * @param item
     */
    change_price(item){
      if ((item.goodsStatus !== 1 && this.selectItem === '游戏账号') || (item.goodsStatus !== 2 && this.selectItem === '装备道具')) {
        this.$message({
          type: 'error',
          center: true,
          message: '商品不在出售中，无法修改出价！'
        })
        return
      }
      this.$parent.change_price_confirm(item)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-dialog__header,/deep/.el-dialog__body {
  padding: 0 !important;
}
/deep/.tipDialog {
  border-radius: 4px;
  #tipDialog {
    position: relative;
    padding: 26px 34px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;

    .title {
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-main, #353535);
    }

    .text {
      width: 289px;
      margin: 22px 0;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #696969;
      text-align: center;
    }

    .btn_wrapper{
      display: flex;
      justify-content: space-between;
      flex: 1;
      width: 100%;
      .btn {
        width: 130px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        cursor: pointer;
      }
      .btn_cancel{
        color: var(--text-main, #1A1D24);
        background: #fff;
        border: 1.5px solid var(--bg-dark, #1A1D24);
      }
    }

    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }
}
.bargainList {
  .bargainItem {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e2e2e2;
    height: 222px;

    .delBox {
      margin: 0 11px 0 0;
    }

    .img {
      margin: 0 21px 0 0;

      div {
        width: 180px;
        height: 180px;
        border-radius: 4px;
        display: block;
      }
    }

    .baseInfo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 373px;
      height: 180px;
      padding: 0 18px 0 0;
      border-right: 1px solid #e4e4e4;

      .number {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #acacac;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .name {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #000000;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

        .status {
          padding: 1px 8px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          margin: 0 10px 0 0;
        }

      }

      .price {
        display: flex;
        align-items: center;

        .originalPrice {
          display: flex;
          align-items: center;
          margin: 0 26px 0 0;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #000000;

          div {
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            color: var(--text-main, #1A1D24);
          }
        }

        .quotedPrice {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--primary, #FF5A1F);
          img{
            margin-right: 5px;
          }
          div {
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            color: var(--primary, #FF5A1F);
          }
        }

      }

      .zone, .other, .time {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #acacac;
        display: flex;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;

        .browse {
          margin: 0 22px 0 0;
        }
      }

      .zone {
        display: inline;
      }
    }

    .operating {
      width: 272px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .status {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        margin: 0 0 11px;

        img {
          margin: 0 7px 0 0;
        }
      }

      .time {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #acacac;
      }

      .btnGroup {
        > div {
          display: flex;
          align-items: center;

          .btn {
            border-radius: 4px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: CENTER;
            width: 98px;
            height: 28px;
            line-height: 28px;
            color: #FFFFFF;
            background: var(--primary, #FF5A1F);
            border: 1px solid var(--primary, #FF5A1F);
            margin: 19px 5px 0;
            cursor: pointer;
          }

          .cusSer {
            width: 142px;
            height: 34px;
            line-height: 34px;
          }

          .edit,.modify{
            color: var(--text-main, #1A1D24);
            background: #FFFFFF;
            border: 1.5px solid var(--bg-dark, #1A1D24);

            span:hover {
              color: var(--primary, #FF5A1F);
            }
          }

          .cusSer,
          .other{
            width: 98px;
            height: 28px;
            line-height: 28px;
            color: var(--text-main, #1A1D24);
            background: #FFFFFF;
            border: 1.5px solid var(--bg-dark, #1A1D24);
          }

          .cusSer {
            width: 142px;
            height: 34px;
            line-height: 34px;
          }
          .btn_size{
            width: 78px;
            height: 30px;
          }
        }
      }
    }

  }

  .bargainItem:hover {
    background: var(--bg-tag, #F0EDE8);
  }
}

</style>
